<template>
  <p>
    <DiceItem :label="attackLabel" :dice="attack.attack"></DiceItem>
    <br />
    <DiceItem :label="damageLabel" :dice="attack.damage"></DiceItem>
  </p>
</template>

<script>
import DiceItem from "./DiceItem";
export default {
  name: "AttackBlock",
  components: { DiceItem },
  props: {
    attack: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      attackLabel: "Attack",
      damageLabel: "Damage"
    };
  }
};
</script>

<style scoped></style>
